import { Navigate, useLocation, useParams } from "react-router";
import { ROUTES } from "../routes";

export function RedirectPreserveSearch({ basePath, targetPath }: { basePath: string; targetPath: string }) {
    const { search } = useLocation();

    return <Navigate replace to={{ pathname: `${basePath}/${targetPath}`, search }} />;
}

export function LegacyFormRedirect({ basePath }: { basePath: string }) {
    const { publicId, formDataNumber } = useParams();

    return <Navigate replace to={`${basePath}/${ROUTES.PUBLIC_FORM.urlPath}/${publicId}/${formDataNumber}`} />;
}
